import React, {createContext, useContext, useState} from 'react';
import PropTypes from 'prop-types';
import CPageError from '../components/PageError';
import CNotFound from '../components/NotFound';

const CMSBuilderContext = createContext();


/**
 * Context to handle the draggable components
 * In order to used you must to set the current Form
 * @author Yadian
 * @since v0.0.1
 * */
const CMSBuilderProvider = ({children, NotFound, PageError, ...props}) => {
  const [form, setForm] = useState(null);
  return (
    <CMSBuilderContext.Provider value={{
      form,
      setForm,
      NotFound,
      PageError
    }} {...props} >
      {children}
    </CMSBuilderContext.Provider>
  );
};

function useCMSBuilder() {
  const context = useContext(CMSBuilderContext);
  if (context === undefined) {
    throw new Error('useUIBuilder must be used within a CMSBuilderProvider');
  }
  const {
    form,
    setForm,
    NotFound,
    PageError
  } = context;

  return {
    form,
    NotFound,
    PageError,
    setForm,
  };
}

CMSBuilderProvider.propTypes = {
  NotFound: PropTypes.any,
  PageError: PropTypes.any,
  children: PropTypes.any
};


export {CMSBuilderProvider, useCMSBuilder};

CMSBuilderProvider.defaultProps = {
  PageError: CPageError,
  NotFound: CNotFound
};
